import styles from "./Carousel.module.css";

export const Carousel = ({ images }: { images: string[] }) => {
  return (
    <ul className={styles.container}>
      {images.map((image) => (
        <li key={image}>
          <img src={image} />
        </li>
      ))}
    </ul>
  );
};
